import { useMemo } from 'react';
import { toast } from 'sonner';

import {
  useDeleteConfiguration,
  useGetConfiguration,
  useUpdateConfiguration,
} from '@/hooks/useConfiguration';

const PIUS_ENABLED_CONFIG = 'pius-enabled';

export function usePiusEnabled(email: string) {
  const { data: configurations, status } = useGetConfiguration({
    email,
    disableCache: true,
  });

  const { mutateAsync: updateConfiguration, isPending: isEnabling } =
    useUpdateConfiguration({ email });
  const { mutateAsync: deleteConfiguration, isPending: isDisabling } =
    useDeleteConfiguration({ email });

  const isPiusEnabled = useMemo(() => {
    const config = configurations?.find(c => c.name === PIUS_ENABLED_CONFIG);
    return config?.value === true;
  }, [configurations]);

  const handleEnable = async () => {
    try {
      await updateConfiguration({ name: PIUS_ENABLED_CONFIG, value: true });
      toast.success('Pius Discovery enabled');
    } catch {
      toast.error('Failed to enable Pius Discovery');
    }
  };

  const handleDisable = async () => {
    try {
      await deleteConfiguration({ name: PIUS_ENABLED_CONFIG });
      toast.success('Pius Discovery disabled');
    } catch {
      toast.error('Failed to disable Pius Discovery');
    }
  };

  return {
    isPiusEnabled,
    isLoading: status === 'pending',
    isEnabling,
    isDisabling,
    handleEnable,
    handleDisable,
  };
}
